import { BatchActions, Boards, Distribution, Postings } from 'src/api';
import { DistributionStateInterface } from 'src/store/distribution/state';

// type R = Record<any, number>;
// function keyById<T extends R>(collection: T[], key = 'id') {
//   return collection.reduce((acc: { [id: number]: T }, el: T) => {
//     const val = el[key];
//     acc[val] = el;
//     return acc;
//   }, {});
// }

export function SET_EXECUTIONS(
  state: DistributionStateInterface,
  records: Distribution.Types.Execution[]
) {
  state.executions = records;
}

export function ADD_EXECUTIONS(
  state: DistributionStateInterface,
  records: Distribution.Types.Execution[]
) {
  state.executions = [...state.executions, ...records];
}

export function SET_EXECUTIONS_OFFSET(
  state: DistributionStateInterface,
  offset: number
) {
  state.dayOffset = offset;
}

export function SET_BOARDS(
  state: DistributionStateInterface,
  boards: Boards.Types.Board[]
) {
  state.boards = boards;
}

export function ADD_BOARDS(
  state: DistributionStateInterface,
  boards: Boards.Types.Board[]
) {
  state.boards = [...state.boards, ...boards];
}

export function UPDATE_BOARDS(
  state: DistributionStateInterface,
  boards: Boards.Types.Board[]
) {
  boards.forEach((board: Boards.Types.Board) => {
    const pos = state.boards.findIndex((item) => item.id === board.id);
    state.boards.splice(pos, 1, board);
  });
}

export function INCLUDE_LOCAL_OUTREACH(
  state: DistributionStateInterface,
  include: boolean
) {
  state.includeLocalOutreach = include;
}

export function SET_POSTINGS(
  state: DistributionStateInterface,
  postings: Postings.Types.Posting[]
) {
  state.postings = postings;
}

export function ADD_POSTINGS(
  state: DistributionStateInterface,
  postings: Postings.Types.Posting[]
) {
  state.postings = [...postings, ...state.postings];
}

export function SET_BOARD_BATCH_ACTION_EXECUTIONS(
  state: DistributionStateInterface,
  payload: BatchActions.Types.BatchActionExecutionRecord[]
) {
  // state.boardBatchActionExecutions = new Map(payload.map(r => [r.id, r]));
  state.boardBatchActionExecutions = {
    ...payload.reduce(
      (acc, record) => ({
        ...acc,
        [record.id]: record,
      }),
      state.boardBatchActionExecutions
    ),
  };
}

/*
export function SET_BOARD_BATCH_ACTION_EXECUTION(
  state: DistributionStateInterface,
  payload: { arn: string; record: BatchActionExecutionRecord }
) {
  // const index = state.boardBatchActionExecutions.findIndex(
  //   r => r.id === payload.record.id
  // );
  // state.boardBatchActionExecutions = [
  //   ...state.boardBatchActionExecutions,
  //   payload,
  // ];
}
*/
